import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { customerApi, formatApiError } from "../lib/customerApi";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await customerApi.post("/customer/reset-password", { token, new_password: password });
      toast.success("Password updated — please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err, "Reset link is invalid or expired"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <p className="eyebrow text-center">Set a new password</p>
        <h1 className="font-serif-display text-5xl text-center mt-3">Almost there</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="eyebrow block mb-2">New password</span>
            <input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-[#a89e80] bg-transparent px-4 py-3 outline-none focus:border-[#1A1A1A]" data-testid="reset-password-new" />
          </label>
          <label className="block">
            <span className="eyebrow block mb-2">Confirm password</span>
            <input required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full border border-[#a89e80] bg-transparent px-4 py-3 outline-none focus:border-[#1A1A1A]" data-testid="reset-password-confirm" />
          </label>
          <button disabled={loading || !token} className="w-full bg-[#1A1A1A] text-[#c3ba9e] py-4 text-[11px] tracking-[0.28em] uppercase disabled:opacity-60" data-testid="reset-submit">
            {loading ? "Saving…" : "Reset password"}
          </button>
        </form>
        <p className="text-center mt-8 text-sm text-[#4A4A4A]">
          <Link to="/login" className="text-[#1A1A1A] underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
